// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".selection-title[data-v-efad7b20] {\n  font-size: 18px !important;\n  color: #444444;\n  font-weight: 300;\n}", ""]);
// Exports
module.exports = exports;
